import styled from 'styled-components'

export const StyledISvgIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`

export const SvgImg = styled.img``
